
































import { Vue, Prop, Component } from 'vue-property-decorator'
import videojs from 'video.js'
import * as utils from '@ivy/fts/utils'
@Component
export default class VideoModal extends Vue {
  @Prop() videoUrl: string
  @Prop() videoUrlExtra: string
  @Prop() loadImgUrl: string
  @Prop() playId: any
  @Prop() hasAccess: boolean | string | number
  @Prop() finishRate: number | string
  @Prop({ default: 'default' }) btnType: string
  @Prop({ default: false }) isTallVideo: boolean | string | number
  @Prop({ default: false }) isIndexTallVideo: boolean | string | number
  // @Prop() picWidth: number
  @Prop({ default: false }) isLandingPage: boolean | string | number
  video: any = ''
  playing: boolean = false
  videoCanPlay: boolean = true
  hasAccount: boolean = false
  hasAccountFinish: boolean = false
  get playBtnSrc() {
    return {
      default: require('../../assets/icons/player.png')
    }[this.btnType]
  }
  get playClass() {
    return 'play'
  }
  get imgClass() {
    return 'loadImg'
  }
  get playtingStyle() {
    if (!this.playing) return
    if (this.isTallVideo) return 'tall-playing'
    if (this.isIndexTallVideo) return 'index-tall-playing'
    return 'playing'
  }
  mounted() {
    console.dir(document.getElementById('video2'))
    if (!this.hasAccess) return this.showPrompt('sale')
    this.video = videojs('video2', {
      playbackRates: [0.5, 1, 1.5, 2]
    })
    this.video.on("ended", e => {
      this.playing = false
      this.$emit("togglePlay", 1, true)
    })
    this.video.on("pause", e => {
      this.playing = false
      this.$emit('playDurationPoint', 'pause')
    })
    this.video.on("play", e => {
      this.playing = true
      if (!this.hasAccount) {
        this.hasAccount = true
        this.$emit('addPlayCount')
      }
      this.$emit('playDurationPoint', 'play')
    })
    this.video.on("canplaythrough", e => {
      this.$Indicator.close()
      this.videoCanPlay = true
    })
    this.video.on("timeupdate", e => {
      let currentTime = this.video.cache_.currentTime
      let duration = this.video.cache_.duration
      let rate = currentTime / duration
      if (+rate >= this.finishRate && !this.hasAccountFinish) {
        this.hasAccountFinish = true
        this.$emit("accountPlayFinish")
      }
    })
  }
  async showPrompt(type = 'end') {
    this.$emit('showBuyPrompt', type)
  }
  playVideo() {
    if (!this.hasAccess) return this.showPrompt('sale')
    this.playing = true
    this.video.play()
  }
  destroyed() {
    this.video && this.video.dispose()
  }
}
